module.exports = __webpack_public_path__ + "static/media/icon_date_history.76289506.svg";